exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group .btn[data-v-39f20603]{min-width:32px}", ""]);

// exports
